import velocity from 'velocity-animate';
import bem from '../modules/bem';
import utils from '../modules/utils';

class Sidebar {

	static get block() {
		return bem.block('sidebar');
	}

	constructor($sidebar){

		this.$body = document.querySelector('body');
		this.$sidebar = $sidebar;
		this.$tabs = {
			wrapper: $sidebar.querySelector(Sidebar.block.selector('tabs-wrapper')),
			list: $sidebar.querySelector(Sidebar.block.selector('tabs')),
			links: $sidebar.querySelectorAll(Sidebar.block.selector('tabs') + ' a')
		};
		this.$content = {
			wrapper: $sidebar.querySelector(Sidebar.block.selector('content-wrapper')),
			entries: $sidebar.querySelectorAll(Sidebar.block.selector('content')),
		};

		this.id = this.$sidebar.dataset.id;
		this.settings = {
			busy: false,
			open: false,
			// activeTab: userSettings.sidebar[this.id].activeTab || null
		};

		this.init = this.init.bind(this);
		this.onClickSetup = this.onClickSetup.bind(this);
		this.toggleSidebar = this.toggleSidebar.bind(this);

		this.init();

	}

	init(){

		// add click listener to tabs
		this.onClickSetup();

		// check if there's already an active tab and open it (cookie)
		// if( this.settings.activeTab ){
		// 	for( let i = 0; i < this.$tabs.links.length; i++ ){
		// 		const $tab = this.$tabs.links[i];

		// 		if( $tab.hash.replace('#', '') === this.settings.activeTab ){
		// 			$tab.click();
		// 		}
		// 	}
		// }

	}

	onClickSetup(){

		// const $body = $(this.$body);

		// const id = this.id;
		const settings = this.settings;

		const toggleSidebar = this.toggleSidebar;

		utils.delegate(this.$tabs.list, 'click', 'a', function(e){

			e.preventDefault();

			// if we're busy, or already on the active tab, do nothing
			if( settings.busy ){
				return;
			}

			settings.busy = true;

			const $link = this;
			const target = $link.hash;
			const isActive = $link.classList.contains(bem.states.active);

			toggleSidebar(!isActive, target);

			// click outside
			// if( isActive ){
			// 	$body.off('click.sidebar-' + id);
			// }

			// setTimeout(function(){

			// 	if( settings.open ) return;

			// 	$body
			// 		.on('click.sidebar-' + id, function(event){

			// 			if( $(event.target).closest(Sidebar.block.selector()).length ) return;

			// 			toggleSidebar(false, false);

			// 			$body.off('click.sidebar-' + id);

			// 		});

			// }, 50);

		});

	}

	toggleSidebar(force, hash){

		const $sidebar = this.$sidebar;
		const $content = this.$content;

		const id = this.id;
		const settings = this.settings;

		const target = hash ? hash.replace('#', '') : false;

		// set active tab
		for( let i = 0; i < this.$tabs.links.length; i++ ){
			const $tab = this.$tabs.links[i];
			// const $label = $tab.querySelector('.text');
			const tabID = $tab.hash.replace('#', '');
			const tabActive = target === tabID && force;

			// if not active, and now is active
			if( !$tab.classList.contains(bem.states.active) && tabActive ){

				// $label.style.width = $label.offsetWidth + 'px';
				// $label.textContent = 'Close';

				$tab.classList.add(bem.states.active);

			}else if( $tab.classList.contains(bem.states.active) && !tabActive ){

				// $label.textContent = $tab.dataset.label;
				// $label.style.removeProperty('width');

				$tab.classList.remove(bem.states.active);

			}
		}

		if( force ){

			// set active content
			for( let i = 0; i < $content.entries.length; i++ ){
				const $entry = $content.entries[i];

				$entry.classList.toggle(bem.states.active, target === $entry.id);
			}

			// open sidebar (if not open already)
			if( !settings.open ){

				velocity($sidebar, {
					translateX: id === 'right' ? ['-100%', '0%'] : ['100%', '0%']
				}, {
					duration: 200,
					complete: function(){

						$sidebar.classList.add(bem.states.active);

						settings.open = true;

						settings.busy = false;

						// set cookie
						// userSettings.sidebar[id].activeTab = target;
						// updateUserSettings();

					}
				});

			}else{

				settings.busy = false;

			}

		}else{

			// close sidebar
			velocity($sidebar, {
				translateX: this.id === 'right' ? ['0%', '-100%'] : ['0%', '100%']
			}, {
				duration: 200,
				complete: function(){

					$sidebar.classList.remove(bem.states.active);

					settings.open = false;

					settings.busy = false;

					// hide all active content
					for( let i = 0; i < $content.entries.length; i++ ){
						const $entry = $content.entries[i];

						$entry.classList.remove(bem.states.active);
					}

					// remove cookie
					// userSettings.sidebar[id].activeTab = false;
					// updateUserSettings();

				}
			});

		}

		// const tabs = new atr.classes.Tabs(this.$sidebar.querySelector('.js-tabsx'));
		// tabs.overflowReset();

	}

}

module.exports = () => {

	[].slice
		.call(document.querySelectorAll(Sidebar.block.selector()))
		.forEach($sidebar => new Sidebar($sidebar));

};



// WEBPACK FOOTER //
// ./src/js/layout/sidebar.js